<template>
  <div class="snack-bar">
    {{ $store.state.snackBar.messages[index]}}
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js'

export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },

  mounted: function () {
    var timeline = anime.timeline({
      targets: '.snack-bar',
      duration: 400,
      endDelay: 3000,
      easing: 'linear',
    })
    timeline.add({
      translateY: -45,
      opacity: 1.0
    }).add({
      translateY: 0,
      opacity: 0,
      complete: () => {
        this.$store.commit(
          'snackBar/removeMessage',
          this.index
        )
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.snack-bar {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75vw;
  height: 50px;
  color: white;
  background-color: rgba(44, 62, 80, 1.0);
  border-radius: 4px;
  opacity: 0.2;
}
</style>
